import { render, staticRenderFns } from "./RemoveAccount.vue?vue&type=template&id=729703cb&lang=html&"
import script from "./RemoveAccount.vue?vue&type=script&lang=js&"
export * from "./RemoveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports